import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/config";

const BOOT_LINES = [
  "CORE ........ OK",
  "AGENTS ...... OK",
  "MACHINES .... OK",
  "NETWORK ..... OK",
];

const LoadingScreen = ({ onDone }) => {
  const [lines, setLines] = useState(0);
  useEffect(() => {
    const timers = BOOT_LINES.map((_, i) => setTimeout(() => setLines(i + 1), 450 + i * 320));
    const done = setTimeout(onDone, 450 + BOOT_LINES.length * 320 + 500);
    return () => { timers.forEach(clearTimeout); clearTimeout(done); };
  }, [onDone]);
  return (
    <motion.div
      data-testid="loading-screen"
      className="fixed inset-0 z-[90] bg-arc-black flex flex-col items-center justify-center scanlines"
      exit={{ opacity: 0 }}
    >
      <motion.img
        src={ASSETS.logo}
        alt="ARCMECH"
        className="w-36 sm:w-44 h-auto mb-8"
        initial={{ opacity: 0, scale: 0.94 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      />
      <div className="font-mono text-[10px] tracking-[0.4em] text-arc-cyan mb-1">ARCMECH SYSTEM</div>
      <div className="font-mono text-[10px] tracking-[0.25em] text-arc-silver/50 mb-6">INITIALIZING MACHINE NETWORK...</div>
      <div className="w-56 h-px bg-arc-metal mb-6 overflow-hidden">
        <motion.div className="h-full bg-arc-electric" initial={{ width: "0%" }} animate={{ width: "100%" }} transition={{ duration: 1.9, ease: "easeInOut" }} />
      </div>
      <div className="font-mono text-[11px] tracking-[0.2em] space-y-1.5 h-24" aria-live="polite">
        {BOOT_LINES.slice(0, lines).map((l) => (
          <div key={l} className="text-arc-silver/60">
            {l.replace("OK", "")}<span className="text-arc-green">OK</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
